// App.js
import React from 'react';
import { BrowserRouter, Route, Link, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomPage';
import ProductsPage from './pages/ProductsPage';
import AboutPage from './pages/AboutPage';

function App() {
    
    return (
        <div>
            <h1>Lesson 21</h1>
            <BrowserRouter>
                <div>
                    <nav>
                        <ul>
                            <li>
                            <Link to="/" className="nav-link">Home</Link>
                            </li>
                            <li>
                            <Link to="/products" className="nav-link">Products</Link>
                            </li>
                            <li>
                            <Link to="/about" className="nav-link">About</Link>
                            </li>
                        </ul>
                    </nav>

                    <Routes>
                        <Route path="/" exact Component={HomePage} />
                        <Route path="/products" Component={ProductsPage} />
                        <Route path="/about" Component={AboutPage} />
                    </Routes>
                </div>
            </BrowserRouter>
        </div>
    );
}

export default App;